import { render, staticRenderFns } from "./card-products-select.vue?vue&type=template&id=eab945aa&"
import script from "./card-products-select.vue?vue&type=script&lang=js&"
export * from "./card-products-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports